import * as React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import { navigationStore } from '@app/Stores/NavigationStore';
import { devInfoStore } from '@app/Stores/DevInfoStore';
import { LoginSection } from './AzureAuth';
import UrlService from '@app/Services/UrlService';
import { securityService } from '@app/Services/SecurityService';
import { Permissions } from '@app/AppConstants';

@observer
export class NavMenu extends React.Component<{}, {}> {

    render() {
        if (UrlService.isPrintMode) return null;
        const {hasPermission, hasAnyPermission} = securityService;
        return (
            <div className="main-nav">
                <div className="main-nav-menu">
                    <div className="main-nav-menu-left">
                        <div className="main-nav-brand" style={{ backgroundImage: 'url("images/logo.png")' }}>{this.renderLink('/', '')}</div>
                        <div className="main-nav-group">
                            <span className="main-nav-group-name">{this.renderLink('/', 'Home')}</span>
                            <div className="main-nav-links" />
                        </div>
                        {hasAnyPermission([Permissions.ViewHealthBoard, Permissions.ViewJobList, Permissions.ViewMasterDataItems]) && 
			            <div className="main-nav-group">
                            <span className="main-nav-group-name">Tools</span>
                            <div className="main-nav-links">
                                {hasPermission(Permissions.ViewHealthBoard) && this.renderLink('/health-board', 'Health Board' )}
                                {hasPermission(Permissions.ViewJobList) && this.renderLink('/job-list', 'Jobs list')}
                                {hasPermission(Permissions.ViewMasterDataItems) && this.renderLink('/master-data', 'Master Data')}
                                {hasPermission(Permissions.ViewJobList) && this.renderLink('/features', 'Features')}
                            </div>
                        </div>}
                        {hasAnyPermission([Permissions.ViewPersonReport, Permissions.ViewSeniorityReport]) &&
                            <div className="main-nav-group">
                                <span className="main-nav-group-name">Reports</span>
                                <div className="main-nav-links">
                                    {hasPermission(Permissions.ViewPersonReport) && this.renderLink('/person-report', 'Action needed Report')}
                                    {hasPermission(Permissions.ViewEmployeeSummaryReport) && this.renderLink('/employee-summary-report', 'Employee Summary Report')}
                                    {hasPermission(Permissions.ViewSeniorityReport) && this.renderLink('/seniority-report', 'Seniority Report')}
                                </div>
                            </div>
                        }
                    </div>
                    <div className="main-nav-menu-left">
                        <div className={('main-nav-application ' + devInfoStore.envClassName)}>
                            PersonData: <span className="app-name">{devInfoStore.appEnvironment}</span>
                            - Version:<span className="app-version">{devInfoStore.appVersion}</span>
                        </div>
                    </div>
                    <div className="main-nav-menu-right">
                        <LoginSection />
                    </div>
                </div>
            </div>
        );
    }
    
    renderLink = (toUrl: string, title: string, id?: string) => {
        const isActive = navigationStore.currentLocation && navigationStore.currentLocation.pathname === toUrl;
        return <Link to={toUrl} className={'nav-link' + (isActive ? ' active' : '')} id={id}>{title}</Link>;
    };
}
